<template>
  <div class="mixin-components-container">
    <div class="header">
      <span>语音内容</span>
      <!-- <el-button
        v-show="!this.fileData"
        plain
        type="primary"
        size="small"
        @click="getSignText"
        >点击翻译</el-button
      > -->
      <el-button
        v-show="recordHref.length"
        plain
        type="primary"
        size="small"
        @click="downloadRecord"
        >点击下载录音</el-button
      >
    </div>
    <div
      class="container"
      element-loading-text="拼命加载中"
      v-loading="loading"
    >
      <el-tree v-if="!this.textData"></el-tree>
      <ul v-else>
        <li class="blue">
          <span>{{ textData }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getData } from "@/api/index";
export default {
  props: {
    fileId: Number,
    fileData: String,
    recordHref: String,
  },
  data() {
    return {
      textData: "",
      loading: false,
    };
  },
  methods: {
    downloadRecord() {
      window.open(this.recordHref)
    },
    async getSignText() {
      this.loading = true;
      await getData(
        "call.CallController/recordingToWordAction?id=" + this.fileId
      ).then((res) => {
        if (res.code == 200) {
          this.textData = res.data.recording_word;
          this.changeFileData();
          this.loading = false;
        } else {
          this.loading = false;
          this.textData = this.fileData;
        }
      });
    },
    changeFileData() {
      this.$emit("changeFileData");
    },
  },
  created() {
    if (this.fileData) {
      this.textData = this.fileData;
    }
  },
  watch: {
    fileData() {
      if (this.fileData) {
        this.textData = this.fileData;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tomato {
  background-color: #f8ece5;
}
.blue {
  background-color: #e1f0ff;
}
::-webkit-scrollbar {
  width: 6px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: #eee;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: #f4f4f4;
}
ul li {
  list-style: none;
}
.mixin-components-container {
  background-color: white;
  margin-top: 20px;
  .header {
    padding: 10px;
    border-bottom: 1px solid #e9e9e9;
    span {
      font-size: 20px;
      margin-right: 20px;
    }
  }
  .container {
    padding: 15px 15px 10px;
  }
  ul {
    height: 440px;
    margin-left: -26px;
    overflow-y: scroll;
  }
  li {
    margin-top: 5px;
    margin-right: 10px;
  }

  span {
    text-indent: 1rem;
    font-size: 12px;
    color: #444;
  }
}
</style>
